import { createContext } from "react"

const PageContext = createContext({
  i18n_lang: "en_US",
  i18n_refs: [],
})

export default PageContext
